import { useCardsRouterContext } from '@apps/card/Card.routes';
import { getDimensions } from '@apps/card/Card.utils';
import { ChoiceGroup, useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import React from 'react';
import { getOrientation, useTemplatesBySize } from './OrientationChoiceGroup';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';

export const SizeChoiceGroup = (props: { templateId: string }) => {
  const { templateId } = props;
  const [draft] = useCustomizationContext(draft => draft);
  const category = draft.stationeryTemplateCategory;
  const dimensions = getDimensions(draft.config.card);
  const orientation = getOrientation(dimensions.width, dimensions.height);

  const templates = useTemplatesBySize(category, draft.template.themeId).filter(t => {
    return orientation === getOrientation(t.widthInches, t.heightInches);
  });

  const { goToProductDetailsPage } = useCardsRouterContext();

  if (!templates.length) return null;
  return (
    <ChoiceGroup
      title="Size"
      value={templateId}
      setValue={nextTemplateId => {
        goToProductDetailsPage('wedding', category, draft.template.themeId, nextTemplateId, 'replace');
      }}
      choices={templates.map(t => t.id)}
      getName={(id: string) => {
        const { widthInches, heightInches } = templates.find(t => t.id === id)!;
        if (category === StationeryTemplateCategoryEnum.napkin) {
          if (widthInches === 4.75) return 'Cocktail';
          if (widthInches === 6.5) return 'Luncheon';
        }
        return `${widthInches} × ${heightInches} inches`;
      }}
      textTransform="none" // keep "inches" lowercase
      minHeight={55}
    />
  );
};
